(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hip-bundle-builder"] && !Shopify.designMode) return;
  try {
    
(function(){
  function euro(c){try{return new Intl.NumberFormat("nl-NL",{style:"currency",currency:"EUR"}).format(c/100);}catch(e){return "€"+(c/100).toFixed(2);}}
  // Parse a variant title to exact sizes: "90/100 x 200/220 cm" -> {ws:[90,100],ls:[200,220]}
  function sizeOf(title){
    var t=(title||"").toLowerCase().replace(/\s/g,"");
    var m=t.match(/(\d{2,3}(?:\/\d{2,3})?)[x×](\d{2,3}(?:\/\d{2,3})?)/);
    if(!m) return null;
    return {ws:m[1].split("/").map(Number),ls:m[2].split("/").map(Number)};
  }
  // Dekbed(overtrek)-breedte -> standaard hoeslaken/molton-maat (Edwins tabel)
  var MATTRESS_DEFAULT={140:[90,200],200:[140,200],240:[160,200],260:[180,200]};
  // Dekbedovertrek-materiaal -> geadviseerd hoeslaken-materiaal
  var MATCH_SHEET={"Katoen":"Katoen","Katoensatijn":"Katoensatijn","Teddy fleece":"Teddy fleece","Flanel":"Flanel","Microvezel":"Jersey"};
  var MAX_PCT=15; // harde bovengrens: de bundelkorting mag nooit hoger worden
  function parseTiers(str){var out=[];(str||"").split(/[\n,;]+/).forEach(function(x){var m=x.split(":");if(m.length===2){var c=parseInt(m[0],10),p=parseFloat(m[1]);if(!isNaN(c)&&!isNaN(p)&&c>0){if(p>MAX_PCT)p=MAX_PCT;out.push([c,p]);}}});out.sort(function(a,b){return a[0]-b[0];});return out;}
  function tiersAfgetopt(str){return parseTiers(str).map(function(t){return t[0]+":"+t[1];}).join(",");}
  var COLORMAP={"off-white":"#f2ece2","offwhite":"#f2ece2","creme":"#eee5d5","crème":"#eee5d5","ivoor":"#efe8d8","wit":"#f4f1ea","licht zand":"#e2d3b8","lichtzand":"#e2d3b8","zand":"#d9c3a3","beige":"#d8cbb4","taupe":"#b0a696","klei":"#b08d76","mink":"#8f7d6b","bruin":"#7a5c46","donkerbruin":"#5a4433","cognac":"#a5673f","terra":"#b56a4a","roze":"#e8c4cf","oudroze":"#d8a7b0","oud roze":"#d8a7b0","rood":"#8f2f2f","wine":"#6e2f38","paars":"#6b5b7b","donkerblauw":"#2b3a55","navy":"#24304d","denim blauw":"#4a6484","denim":"#4a6484","adria blauw":"#3f6f9f","blauw":"#5b7089","lichtblauw":"#9fb6cc","ijsblauw":"#cfe0ea","aqua":"#7fb0bf","petrol":"#2f6f76","donkergroen":"#33503a","olijfgroen":"#6b6a3a","olijf":"#6b6a3a","misty groen":"#8fa39a","lichtgroen":"#8aa37a","sage":"#9caa92","groen":"#4a6b4a","antraciet":"#3f3f42","donkergrijs":"#5b5b5b","grijs":"#9a968f","lichtgrijs":"#c3c0b8","zwart":"#232323","goud":"#b9962e","zilver":"#c4c4c0","okergeel":"#c99a2e"};
  var COLORWORDS=Object.keys(COLORMAP).sort(function(a,b){return b.length-a.length;});
  function deriveColor(title){var tl=(title||"").toLowerCase();for(var i=0;i<COLORWORDS.length;i++){var w=COLORWORDS[i];var re=new RegExp("(^|[^a-z])"+w.replace(/[.*+?^${}()|[\]\\]/g,"\\$&")+"([^a-z]|$)");if(re.test(tl))return w;}return null;}
  function initColors(root){
    root.querySelectorAll('.bb-opt[data-title]').forEach(function(c){
      var t=c.getAttribute("data-title");var w=deriveColor(t);var label=c.querySelector(".bb-color");var dot=c.querySelector(".bb-dot[data-swatch]");var name;
      if(w){name=w.charAt(0).toUpperCase()+w.slice(1);if(dot){dot.style.background=COLORMAP[w];dot.hidden=false;}}
      else{name=t;}
      if(label)label.textContent=name;c.setAttribute("data-name",name);
    });
  }
  function track(ev,data){try{window.dataLayer=window.dataLayer||[];var o={event:ev};for(var k in data)o[k]=data[k];window.dataLayer.push(o);}catch(e){}}
  function initRoot(root){
    if(root.dataset.bbInit) return; root.dataset.bbInit="1";
    initColors(root);
    var sel={};var qty={};var curDuvet=null;var tabsAPI={};
    var order=["design","dekbed","pillow","sheet","protector"];
    var tiers=parseTiers(root.getAttribute("data-tiers"));
    var minCount=tiers.length?tiers[0][0]:1;
    var bundleId=(root.getAttribute("data-bundle-id")||"hoofd").trim();
    track("hip_bundle_view",{bundle_id:bundleId,page:location.pathname});
    function tierPct(n){var p=0;for(var i=0;i<tiers.length;i++){if(n>=tiers[i][0])p=tiers[i][1];}return p;}
    function nextTier(n){for(var i=0;i<tiers.length;i++){if(tiers[i][0]>n)return tiers[i];}return null;}
    function rowHtml(name,val){return '<div class="bb-row"><span class="bb-row-name">'+name+'</span><span>'+val+'</span></div>';}
    // vind in een select de eerste beschikbare optie met exact maat w x l (of alleen breedte als fallback)
    function findSize(s,w,l,widthOnly){
      var best=null;
      [].forEach.call(s.options,function(o){
        if(!o.value||o.disabled||best)return;
        var z=sizeOf(o.textContent);if(!z)return;
        if(z.ws.indexOf(w)>-1&&(widthOnly||z.ls.indexOf(l)>-1))best=o;
      });
      return best;
    }
    function applyVariant(opt,o){
      opt.setAttribute("data-variant",o&&o.value?o.value:"");
      opt.setAttribute("data-price",o?(o.getAttribute("data-price")||"0"):"0");
      var pr=opt.querySelector(".bb-opt-price");if(pr&&o&&o.value)pr.textContent=euro(parseInt(o.getAttribute("data-price"))||0);
    }
    function selectCard(opt){
      var step=opt.getAttribute("data-step");
      root.querySelectorAll('.bb-opt[data-step="'+step+'"]').forEach(function(o){o.classList.remove("is-sel");});
      opt.classList.add("is-sel");var inp=opt.querySelector("input[type=radio]");if(inp)inp.checked=true;sel[step]=opt;
      if(!qty[step])qty[step]=1;var qn=opt.querySelector(".bb-qty-n");if(qn)qn.textContent=qty[step];
    }
    // Propagatie vanuit een dekbed(overtrek)-keuze:
    // - andere duvet-dropdowns: EXACT dezelfde maat (140x220 blijft 140x220)
    // - hoeslaken/molton-dropdowns: de standaardmaat uit de maattabel
    // Handmatig aangepaste dropdowns (data-manual) worden NOOIT overschreven;
    // hoeslaken/molton-wijzigingen propageren zelf nergens naartoe.
    function setSel(s,o){ if(o&&s.value!==o.value){s.value=o.value;var opt=s.closest(".bb-opt");if(opt&&opt.classList.contains("is-sel"))applyVariant(opt,o);} }
    function propagate(src){
      if(!curDuvet)return;
      var w=curDuvet.ws[0],l=curDuvet.ls[0];
      var md=MATTRESS_DEFAULT[w]||null;
      root.querySelectorAll("select.bb-var").forEach(function(s){
        if(s===src||s.dataset.manual==="1")return;
        var cat=s.getAttribute("data-cat");
        if(cat==="duvet"){ setSel(s,findSize(s,w,l)); }
        else if(cat==="mattress"&&md){ setSel(s,findSize(s,md[0],md[1])||findSize(s,md[0],0,true)); }
      });
    }
    root.querySelectorAll(".bb-opt").forEach(function(opt){opt.addEventListener("click",function(e){
      if(e.target&&e.target.classList&&e.target.classList.contains("bb-radio"))return;
      var step=opt.getAttribute("data-step");
      if(opt.classList.contains("is-sel")){opt.classList.remove("is-sel");var ip=opt.querySelector("input[type=radio]");if(ip)ip.checked=false;delete sel[step];update();return;}
      selectCard(opt);var s=opt.querySelector("select.bb-var");if(s){var o=s.options[s.selectedIndex];if(o&&o.value)applyVariant(opt,o);}
      // advies: dekbedovertrek-materiaal -> passend hoeslaken-materiaal (alleen zolang er nog geen hoeslaken gekozen is)
      if(step==="design"&&!sel.sheet&&tabsAPI.sheet){var mm=MATCH_SHEET[opt.getAttribute("data-material")||""];if(mm)tabsAPI.sheet(mm);}
      update();
    });});
    root.querySelectorAll("select.bb-var").forEach(function(s){
      s.addEventListener("click",function(e){e.stopPropagation();});
      s.addEventListener("change",function(){
        var opt=s.closest(".bb-opt");var o=s.options[s.selectedIndex];
        applyVariant(opt,o);selectCard(opt);
        s.dataset.manual="1";
        if(s.getAttribute("data-cat")==="duvet"){
          var z=sizeOf(o.textContent);
          if(z){ curDuvet=z; propagate(s); }
        }
        update();
      });
    });
    root.querySelectorAll(".bb-opt").forEach(function(opt){
      var body=opt.querySelector(".bb-opt-body");
      if(!body||opt.querySelector(".bb-qty"))return;
      var q=document.createElement("span");q.className="bb-qty";
      q.innerHTML='<button type="button" class="bb-qty-b" data-d="-1" aria-label="minder">&minus;</button><span class="bb-qty-n">1</span><button type="button" class="bb-qty-b" data-d="1" aria-label="meer">+</button>';
      body.appendChild(q);
      q.querySelectorAll(".bb-qty-b").forEach(function(b){b.addEventListener("click",function(e){
        e.stopPropagation();var step=opt.getAttribute("data-step");var cur=(qty[step]||1)+parseInt(b.getAttribute("data-d"),10);if(cur<1)cur=1;if(cur>20)cur=20;qty[step]=cur;
        root.querySelectorAll('.bb-opt[data-step="'+step+'"] .bb-qty-n').forEach(function(n){n.textContent=cur;});update();
      });});
    });
    // materiaal-tabs: groepeer kaarten per materiaal; kleuren die niet bij een materiaal bestaan vallen weg
    root.querySelectorAll(".bb-mat-tabs").forEach(function(tabsEl){
      var step=tabsEl.getAttribute("data-step");
      var cards=[].slice.call(root.querySelectorAll('.bb-opt[data-step="'+step+'"]'));
      var grid=cards.length?cards[0].closest(".bb-grid--slider"):null;
      var mats=[];cards.forEach(function(c){var m=(c.getAttribute("data-material")||"").trim();if(m&&mats.indexOf(m)<0)mats.push(m);});
      function setMaterial(mat){
        [].forEach.call(tabsEl.children,function(t){t.classList.toggle("is-active",t.getAttribute("data-mat")===mat);});
        cards.forEach(function(c){var cm=(c.getAttribute("data-material")||"").trim();c.style.display=(!cm||cm===mat)?"":"none";});
        if(grid){grid.scrollLeft=0;if(grid._updArrows)grid._updArrows();}
        if(sel[step]){var sm=(sel[step].getAttribute("data-material")||"").trim();if(sm&&sm!==mat){sel[step].classList.remove("is-sel");delete sel[step];update();}}
      }
      mats.forEach(function(m){var b=document.createElement("button");b.type="button";b.className="bb-mat-tab";b.textContent=m;b.setAttribute("data-mat",m);b.addEventListener("click",function(){setMaterial(m);});tabsEl.appendChild(b);});
      if(mats.length<=1){tabsEl.style.display="none";}
      if(mats.length){setMaterial(mats[0]);}
      tabsAPI[step]=function(m){if(mats.indexOf(m)>-1)setMaterial(m);};
    });
    // slider-pijltjes: maak horizontale scrollen zichtbaar/bedienbaar (macOS verbergt scrollbars)
    root.querySelectorAll(".bb-grid--slider").forEach(function(grid){
      if(grid.parentNode.classList.contains("bb-slider"))return;
      var wrap=document.createElement("div");wrap.className="bb-slider";
      grid.parentNode.insertBefore(wrap,grid);wrap.appendChild(grid);
      var prev=document.createElement("button");prev.type="button";prev.className="bb-slider-arrow bb-slider-arrow--prev";prev.setAttribute("aria-label","Vorige kleuren");prev.innerHTML="‹";
      var next=document.createElement("button");next.type="button";next.className="bb-slider-arrow bb-slider-arrow--next";next.setAttribute("aria-label","Meer kleuren");next.innerHTML="›";
      wrap.appendChild(prev);wrap.appendChild(next);
      function amt(){return Math.max(180,grid.clientWidth*0.8);}
      prev.addEventListener("click",function(){grid.scrollBy({left:-amt(),behavior:"smooth"});});
      next.addEventListener("click",function(){grid.scrollBy({left:amt(),behavior:"smooth"});});
      function upd(){
        var max=grid.scrollWidth-grid.clientWidth-2;
        var noScroll=max<=2;
        var atStart=grid.scrollLeft<=2, atEnd=grid.scrollLeft>=max;
        prev.hidden=noScroll; next.hidden=noScroll;
        prev.classList.toggle("is-dim",atStart);
        next.classList.toggle("is-dim",atEnd);
        wrap.classList.toggle("is-scrollable",!noScroll);
        wrap.classList.toggle("is-start-hidden",!noScroll&&!atStart);
        wrap.classList.toggle("is-end-hidden",!noScroll&&!atEnd);
      }
      grid._updArrows=upd;
      grid.addEventListener("scroll",upd,{passive:true});
      window.addEventListener("resize",upd);
      upd();
    });
    function update(){
      var total=0,rows="",count=0,incomplete=false;
      order.forEach(function(s){var o=sel[s];if(!o)return;var hv=!!o.getAttribute("data-variant");var qn=qty[s]||1;
        if(!hv){incomplete=true;rows+=rowHtml(o.getAttribute("data-name"),"kies maat");return;}
        count++;var p=(parseInt(o.getAttribute("data-price"))||0)*qn;total+=p;var nm=(qn>1?qn+"× ":"")+o.getAttribute("data-name");rows+=rowHtml(nm,p>0?euro(p):"inbegrepen");});
      var box=root.querySelector(".bb-summary-body");
      if(!rows){box.innerHTML='<p class="bb-empty">Kies je onderdelen — hoe meer je combineert, hoe hoger je voordeel.</p>';}
      else{
        var chip=curDuvet?('<div class="bb-sizechip">Maat: '+curDuvet.ws[0]+'x'+curDuvet.ls[0]+'</div>'):"";
        var pct=tierPct(count),body=chip+rows;
        if(count>0&&pct>0){
          var k=Math.round(total*pct/100),bun=total-k;
          body+='<div class="bb-savebox"><div class="bb-tiernow">'+count+' onderdelen &middot; <strong>'+pct+'% bundelkorting</strong></div><div class="bb-normal"><span>Normaal (los)</span><span class="bb-strike">'+euro(total)+'</span></div><div class="bb-now"><span class="bb-now-label">Bundelprijs</span><span class="bb-now-val">'+euro(bun)+'</span></div><div class="bb-savepill">Je bespaart '+euro(k)+'</div></div>';
        } else if(total>0){
          body+='<div class="bb-partial"><span>Tussenstand</span><span>'+euro(total)+'</span></div>';
        }
        var nt=nextTier(count);
        if(nt){var d=nt[0]-count;body+='<div class="bb-nudge">Voeg nog '+d+' onderdeel'+(d>1?'en':'')+' toe voor <strong>'+nt[1]+'% korting</strong></div>';}
        box.innerHTML=body;
      }
      var ok=(count>=minCount&&!incomplete);
      root.querySelectorAll(".bb-add").forEach(function(b){b.disabled=!ok;});
      var mp=root.querySelector(".bb-mobilebar-price"),mc=root.querySelector(".bb-mobilebar-count");
      if(mp&&mc){
        if(count>0){var pm=tierPct(count);var bn=pm>0?total-Math.round(total*pm/100):total;mp.textContent=euro(bn);mc.textContent=count+" onderdeel"+(count>1?"en":"")+(pm>0?" · "+pm+"% korting":"");}
        else{mp.textContent="";mc.textContent="Kies je onderdelen";}
      }
    }
    function doAdd(btn){
      var tiersStr=tiersAfgetopt(root.getAttribute("data-tiers")||"");var items=[];order.forEach(function(s){var o=sel[s];var v=o&&o.getAttribute("data-variant");if(v)items.push({id:parseInt(v),quantity:(qty[s]||1),properties:{"_bundle":"1","_bundle_group":s,"_bundle_tiers":tiersStr}});});
      if(items.length<minCount)return;var all=root.querySelectorAll(".bb-add");var t=btn.textContent;all.forEach(function(b){b.disabled=true;});btn.textContent="Toevoegen...";
      fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:items})}).then(function(r){return r.json();}).then(function(){track("hip_bundle_add_to_cart",{bundle_id:bundleId,items:items.length});var code=(root.getAttribute("data-code")||"").trim();
        if(code){window.location.href="/discount/"+encodeURIComponent(code)+"?redirect=/cart";return;}
        if(typeof window.upcartRefreshCart==="function")window.upcartRefreshCart();
        if(typeof window.upcartOpenCart==="function"){window.upcartOpenCart();all.forEach(function(b){b.disabled=false;});btn.textContent=t;update();}
        else{window.location.href="/cart";}
      }).catch(function(){all.forEach(function(b){b.disabled=false;});btn.textContent=t;});
    }
    root.querySelectorAll(".bb-add").forEach(function(b){b.addEventListener("click",function(){doAdd(b);});});
    update();
  }
  function run(){document.querySelectorAll(".bb").forEach(initRoot);}
  if(document.readyState!=="loading")run();else document.addEventListener("DOMContentLoaded",run);
  document.addEventListener("shopify:section:load",run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hip-dzo-main"]) return;
  try {
    
(function(){
  function euro(c){return "€ "+(c/100).toFixed(2).replace(".",",");}
  // Harde bovengrens: hoger dan dit mag de bundelkorting nooit worden.
  var MAX_PCT=15;
  // Standaard voor dekbedovertrekken; per sectie te overschrijven (zodat dezelfde
  // sectie ook voor hoeslakens werkt, met de upsell precies andersom).
  var MAATSUB_STD={"140x220":"1-persoons","200x220":"2-persoons","240x220":"lits-jumeaux","260x220":"lits-jumeaux XL"};
  var UPMAAT_STD={"140x220":"90x200","200x220":"140x200","240x220":"160x200","260x220":"180x200"};
  // "140x220=1-persoons, 200x220=2-persoons" -> object
  function parseMap(str,fallback){
    if(!str)return fallback;
    var out={},leeg=true;
    str.split(/[\n,;]+/).forEach(function(p){
      var d=p.split("=");
      if(d.length===2){var k=d[0].trim(),v=d[1].trim();if(k&&v){out[k]=v;leeg=false;}}
    });
    return leeg?fallback:out;
  }
  // Varianttitels verschillen ("200x220" vs "90x200 cm"): normaliseer voor de lookup.
  function maatKey(s){return (s||"").toLowerCase().replace(/\s|cm/g,"");}
  function mapLookup(map,titel){
    if(!map||!titel)return "";
    if(map[titel])return map[titel];
    var k=maatKey(titel);
    for(var key in map){if(maatKey(key)===k)return map[key];}
    return "";
  }
  function init(root){
    if(root.dataset.dzInit)return;root.dataset.dzInit="1";
    var MAATSUB=parseMap(root.getAttribute("data-maatsub"),MAATSUB_STD);
    var HOESLAKEN=parseMap(root.getAttribute("data-upmaat"),UPMAAT_STD);
    var pctAttr=parseFloat(root.getAttribute("data-pct"));var pct=isNaN(pctAttr)?0:pctAttr;
    var tier2Min=parseInt(root.getAttribute("data-cdmin"),10)||0;
    var tier2Pct=parseFloat(root.getAttribute("data-cdpct"))||0;
    if(pct>MAX_PCT)pct=MAX_PCT;
    if(tier2Pct>MAX_PCT)tier2Pct=MAX_PCT;
    var effHuidig=pct;
    var kleur=root.getAttribute("data-kleur")||"";
    // galerij
    var imgs=root.querySelectorAll(".tp-gal-img"),thumbs=root.querySelectorAll(".tp-thumb");
    thumbs.forEach(function(t){t.addEventListener("click",function(){
      var i=t.getAttribute("data-i");
      imgs.forEach(function(im){im.classList.toggle("is-on",im.getAttribute("data-i")===i);});
      thumbs.forEach(function(x){x.classList.toggle("is-on",x===t);});
    });});
    // maat
    var maten=[].slice.call(root.querySelectorAll(".tp-maat"));
    maten.forEach(function(m){
      var sub=m.querySelector("[data-sub]");if(sub)sub.textContent=mapLookup(MAATSUB,m.getAttribute("data-title"));
      m.addEventListener("click",function(){
        maten.forEach(function(x){x.classList.toggle("is-on",x===m);x.setAttribute("aria-checked",x===m?"true":"false");});
        try{var zp=new URLSearchParams(location.search);zp.set("variant",m.getAttribute("data-variant"));history.replaceState(null,"",location.pathname+"?"+zp.toString());}catch(e){}
        update();
      });
    });
    function curMaat(){
      var m=root.querySelector(".tp-maat.is-on");
      if(m)return {id:m.getAttribute("data-variant"),price:parseInt(m.getAttribute("data-price"),10)||0,title:m.getAttribute("data-title")};
      var mt=(root.getAttribute("data-main-title")||"").match(/(\d{2,3})\s*x\s*(\d{2,3})/);
      return {id:root.getAttribute("data-main-variant"),price:parseInt(root.getAttribute("data-main-price"),10)||0,title:mt?mt[1]+"x"+mt[2]:""};
    }
    // aantal
    var qty=1,qn=root.querySelector(".tp-qty-n");
    root.querySelectorAll(".tp-qty-b").forEach(function(b){b.addEventListener("click",function(){
      qty=Math.min(10,Math.max(1,qty+parseInt(b.getAttribute("data-d"),10)));qn.textContent=qty;update();
    });});
    // upsell: één of twee hoeslakenrijen (bv. katoen + jersey). Korting ALLEEN op de add-ons,
    // nooit op het dekbed zelf (vanaf 13-10-2026, via de kind-staffel-functie: _kind_* props).
    var up=root.querySelector("[data-hoeslaken]");
    var rows=up?[].slice.call(up.querySelectorAll("[data-uprow]")).map(function(r){
      return {el:r,sel:r.querySelector(".tp-upsell-sel"),check:r.querySelector(".tp-upsell-check"),zelf:false,opt:null,on:false};
    }):[];
    var extras=up?[].slice.call(up.querySelectorAll("[data-extra]")):[];
    var upQty=1;
    // Suggestie op basis van de dekbedmaat; de klant kan zelf een andere maat kiezen.
    function rowSuggestie(r,maatTitle){
      if(!r.sel)return null;
      var doel=mapLookup(HOESLAKEN,maatTitle);
      var opt=null;
      [].forEach.call(r.sel.options,function(o){if(!opt&&doel&&o.textContent.indexOf(doel)>-1)opt=o;});
      return opt;
    }
    function rowVariant(r,maatTitle){
      if(!r.sel||!r.sel.options.length)return null;
      if(!r.zelf){var s=rowSuggestie(r,maatTitle);if(s)r.sel.value=s.value;}
      return r.sel.options[r.sel.selectedIndex]||null;
    }
    rows.forEach(function(r){
      // geen passende maat bij deze dekbedmaat (bv. peuterbed): niet standaard aanvinken
      if(r.check&&r.sel&&!rowSuggestie(r,curMaat().title))r.check.checked=false;
      if(r.sel)r.sel.addEventListener("change",function(){r.zelf=true;update();});
    });
    if(up){up.querySelectorAll(".tp-upsell-check").forEach(function(c){c.addEventListener("change",update);});}
    // aantal-steppers voor extra's (kussensloop e.d.)
    extras.forEach(function(x){
      x._q=1;
      var row=x.nextElementSibling;
      if(!row||!row.hasAttribute("data-extra-qtyrow"))return;
      x._qrow=row;
      var n=row.querySelector("[data-exq-n]");
      row.querySelectorAll(".tp-upq-b").forEach(function(b){b.addEventListener("click",function(){
        x._q=Math.min(6,Math.max(1,x._q+parseInt(b.getAttribute("data-upd"),10)));if(n)n.textContent=x._q;update();
      });});
    });
    var afr=function(bedrag){return Math.round(bedrag*(1-pct/100));};
    function bereken(){
      var m=curMaat(),anyUp=false,addVol=0,addNu=0;
      rows.forEach(function(r){
        r.opt=rowVariant(r,m.title);
        r.on=!!(r.check&&r.check.checked&&r.opt);
        r.price=r.opt?parseInt(r.opt.getAttribute("data-price"),10)||0:0;
        if(r.on){anyUp=true;addVol+=r.price*upQty;addNu+=afr(r.price*upQty);}
      });
      var sloopTot=0,extraTot=0;
      extras.forEach(function(x){
        if(!x.querySelector(".tp-upsell-check").checked)return;
        var t=(parseInt(x.getAttribute("data-price"),10)||0)*(x._q||1);
        if(x.hasAttribute("data-sloop"))sloopTot+=t;else extraTot+=t;
      });
      var dekbed=m.price*qty;
      var vol=dekbed+addVol+sloopTot+extraTot;
      // dekbed altijd vol; korting alleen op hoeslakens (en kussenslopen) als er een hoeslaken bij zit
      var nu=dekbed+addNu+(anyUp?afr(sloopTot):sloopTot)+extraTot;
      return {m:m,anyUp:anyUp,vol:vol,nu:nu};
    }
    function update(){
      var b=bereken(),m=b.m;
      var priceEl=root.querySelector("[data-price]");if(priceEl)priceEl.textContent=euro(m.price);
      // kussensloop-regel: 2 slopen vanaf 200 cm breed (2-persoons en lits-jumeaux), anders 1
      var sr=root.querySelector("[data-sloopregel]");
      if(sr){var mb=(m.title||"").match(/(\d{2,3})\s*x/);if(mb){var sm=sr.getAttribute("data-sloopmaat");sr.textContent=(parseInt(mb[1],10)>=200?"Inclusief 2 kussenslopen":"Inclusief 1 kussensloop")+(sm?" "+sm:"");}}
      var mainBtnTot=m.price*qty;
      root.querySelectorAll("[data-maintotal]").forEach(function(e){e.textContent=euro(mainBtnTot);});
      if(up){
        rows.forEach(function(r){
          var aan=!!(r.check&&r.check.checked);
          var maatrij=r.el.querySelector("[data-upmaatrij]");if(maatrij)maatrij.hidden=!aan;
          var full=r.el.querySelector("[data-upfull]");if(full)full.textContent=(r.opt&&pct>0)?euro(r.price):"";
          var np=r.el.querySelector("[data-upprice]");if(np)np.textContent=r.opt?euro(pct>0?afr(r.price):r.price):"";
          var bp=r.el.querySelector("[data-uppct]");if(bp){bp.textContent=pct>0?"-"+pct+"%":"";bp.hidden=!(pct>0);}
        });
        extras.forEach(function(x){if(x._qrow)x._qrow.hidden=!x.querySelector(".tp-upsell-check").checked;});
        var bv=up.querySelector("[data-bundelvol]");if(bv)bv.textContent=(b.vol>b.nu)?euro(b.vol):"";
        var bt=up.querySelector("[data-bundeltotal]");if(bt)bt.textContent=euro(b.nu);
        var exAan=extras.some(function(x){return x.querySelector(".tp-upsell-check").checked;});
        var bb=up.querySelector("[data-add-bundel]");if(bb)bb.disabled=!(b.anyUp||exAan);
      }
      // sticky balk
      var ms=root.querySelector("[data-mbarsub]");if(ms)ms.textContent=(m.title?m.title+" · ":"")+kleur;
      var mp=root.querySelector("[data-mbarprice]");if(mp)mp.textContent=euro(mainBtnTot);
    }
    // Het thema rendert de teller in de header alleen serverside; na een fetch-toevoeging
    // werken we hem zelf bij (span.cart-count, verborgen via .visually-hidden bij 0).
    function refreshCartCount(){
      fetch("/cart.js",{headers:{"Accept":"application/json"}})
        .then(function(r){return r.json();})
        .then(function(c){
          var n=c.item_count||0;
          document.querySelectorAll(".cart-count").forEach(function(el){
            el.textContent=n;
            if(n>0)el.classList.remove("visually-hidden");else el.classList.add("visually-hidden");
          });
          try{document.dispatchEvent(new CustomEvent("cart:refresh",{bubbles:true,detail:{cart:c}}));}catch(e){}
        }).catch(function(){});
    }
    function addItems(items,btn){
      var old=btn.textContent;btn.disabled=true;btn.textContent="Toevoegen...";
      fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:items})})
        .then(function(r){if(!r.ok)throw new Error(r.status);return r.json();})
        .then(function(){
          refreshCartCount();
          try{window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:"hip_dzo_add_to_cart",items:items.length,page:location.pathname});}catch(e){}
          if(typeof window.upcartRefreshCart==="function")window.upcartRefreshCart();
          // teller nogmaals bijwerken nadat de slide-cart klaar is met verwerken
          setTimeout(refreshCartCount,1200);
          if(typeof window.upcartOpenCart==="function"){window.upcartOpenCart();btn.textContent=old;btn.disabled=false;}
          else{window.location.href="/cart";}
        })
        .catch(function(){btn.disabled=false;btn.textContent=old;});
    }
    root.querySelectorAll("[data-add-main]").forEach(function(b){b.addEventListener("click",function(){
      var m=curMaat();if(!m.id)return;
      addItems([{id:parseInt(m.id,10),quantity:qty}],b);
    });});
    var bundelBtn=root.querySelector("[data-add-bundel]");
    if(bundelBtn){bundelBtn.addEventListener("click",function(){
      var b=bereken(),m=b.m;if(!m.id)return;
      var korting=b.anyUp&&pct>0;
      // Kind-staffel-functie: hoofdregel (dekbed) krijgt 0%, elke add-on zijn eigen _kind_pct,
      // en alleen als het dekbed (zelfde _kind_id) ook in de winkelwagen zit.
      var hoofd={id:parseInt(m.id,10),quantity:qty};
      if(korting)hoofd.properties={"_kind":"1","_kind_id":"dzo","_kind_group":"main"};
      var items=[hoofd],n=0;
      rows.forEach(function(r){
        if(!r.on)return;n++;
        var it={id:parseInt(r.opt.value,10),quantity:upQty};
        if(korting)it.properties={"_kind":"1","_kind_id":"dzo","_kind_group":"extra-"+n,"_kind_pct":String(pct)};
        items.push(it);
      });
      extras.forEach(function(x){
        if(!x.querySelector(".tp-upsell-check").checked)return;
        var it={id:parseInt(x.getAttribute("data-variant"),10),quantity:x._q||1};
        if(korting&&x.hasAttribute("data-sloop")){n++;it.properties={"_kind":"1","_kind_id":"dzo","_kind_group":"extra-"+n,"_kind_pct":String(pct)};}
        items.push(it);
      });
      addItems(items,bundelBtn);
    });}
    // sticky balk: tonen na scrollen voorbij het koopblok
    var mbar=root.querySelector("[data-mbar]");
    var buy=root.querySelector(".tp-buy");
    if(mbar&&buy&&"IntersectionObserver" in window){
      new IntersectionObserver(function(en){mbar.hidden=en[0].isIntersecting;},{rootMargin:"-80px 0px 0px 0px"}).observe(buy);
    }
    update();
    // teller ook bijwerken als de klant in de slide-cart iets wijzigt en terugkomt
    document.addEventListener("visibilitychange",function(){if(!document.hidden)refreshCartCount();});
    try{window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:"hip_dzo_view",page:location.pathname});}catch(e){}
  }
  function run(){document.querySelectorAll(".dzp").forEach(init);}
  if(document.readyState!=="loading")run();else document.addEventListener("DOMContentLoaded",run);
  document.addEventListener("shopify:section:load",run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hip-kind-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  function euro(c){return "€ "+(c/100).toFixed(2).replace(".",",");}
  function track(ev,data){try{window.dataLayer=window.dataLayer||[];var o={event:ev};for(var k in data)o[k]=data[k];window.dataLayer.push(o);}catch(e){}}
  function init(root){
    if(root.dataset.kpInit)return;root.dataset.kpInit="1";
    var bundleId=(root.getAttribute("data-bundle-id")||"").trim();
    var freeship=parseInt(root.getAttribute("data-freeship"),10)||0;
    // galerij
    var imgs=root.querySelectorAll(".kp-gal-img"),thumbs=root.querySelectorAll(".kp-thumb");
    thumbs.forEach(function(t){t.addEventListener("click",function(){
      var i=t.getAttribute("data-i");
      imgs.forEach(function(im){im.classList.toggle("is-on",im.getAttribute("data-i")===i);});
      thumbs.forEach(function(x){x.classList.toggle("is-on",x===t);});
    });});
    // hoofdvariant + prijs
    var varSel=root.querySelector(".kp-var-sel");
    var basePriceEl=root.querySelector(".kp-price-now");
    function mainVariant(){return varSel?varSel.value:(root.querySelector("[data-main-variant]")||{}).value||root.getAttribute("data-main-variant");}
    var mainPrice=parseInt(root.getAttribute("data-main-price"),10)||0;
    function curMainPrice(){
      if(varSel){var o=varSel.options[varSel.selectedIndex];return parseInt(o.getAttribute("data-price"),10)||mainPrice;}
      return mainPrice;
    }
    // staffel
    var tierBtns=[].slice.call(root.querySelectorAll(".kp-tier"));
    function curTier(){var b=root.querySelector(".kp-tier.is-on");return b?{qty:parseInt(b.getAttribute("data-qty"),10)||1,pct:parseFloat(b.getAttribute("data-pct"))||0}:{qty:1,pct:0};}
    tierBtns.forEach(function(b){b.addEventListener("click",function(){tierBtns.forEach(function(x){x.classList.toggle("is-on",x===b);});update();});});
    // bundelitems
    var bitems=[].slice.call(root.querySelectorAll(".kp-bitem"));
    bitems.forEach(function(bi){
      bi.addEventListener("click",function(e){
        if(e.target.closest(".kp-bsel")||e.target.closest(".kp-blink"))return;
        e.preventDefault();
        var on=!bi.classList.contains("is-on");
        bi.classList.toggle("is-on",on);bi.querySelector(".kp-bcheck").checked=on;update();
      });
      var sel=bi.querySelector(".kp-bsel");
      if(sel){
        sel.addEventListener("click",function(e){e.stopPropagation();});
        sel.addEventListener("change",function(){
          var o=sel.options[sel.selectedIndex];if(!o||!o.value)return;
          bi.setAttribute("data-variant",o.value);
          bi.setAttribute("data-price",o.getAttribute("data-price")||bi.getAttribute("data-price"));
          var u=o.getAttribute("data-url");var lk=bi.querySelector(".kp-blink");
          if(u){bi.setAttribute("data-url",u);if(lk)lk.href=u;}
          if(!bi.classList.contains("is-on")){bi.classList.add("is-on");bi.querySelector(".kp-bcheck").checked=true;}
          update();
        });
      }
      var lk=bi.querySelector(".kp-blink");
      if(lk)lk.addEventListener("click",function(e){e.stopPropagation();});
      // aantal per set-artikel (bv. 2 dekbedden)
      bi.querySelectorAll(".kp-bqty-b").forEach(function(qb){qb.addEventListener("click",function(e){
        e.preventDefault();e.stopPropagation();
        var q=(parseInt(bi.getAttribute("data-qty"),10)||1)+parseInt(qb.getAttribute("data-d"),10);
        if(q<1)q=1;if(q>10)q=10;
        bi.setAttribute("data-qty",q);
        var n=bi.querySelector(".kp-bqty-n");if(n)n.textContent=q;
        if(!bi.classList.contains("is-on")&&q>0){bi.classList.add("is-on");bi.querySelector(".kp-bcheck").checked=true;}
        update();
      });});
    });
    var mainLabel=(root.getAttribute("data-main-label")||"artikel");
    function update(){
      var t=curTier(),mp=curMainPrice();
      var mainTotal=Math.round(mp*t.qty*(1-t.pct/100));
      tierBtns.forEach(function(b){
        var q=parseInt(b.getAttribute("data-qty"),10)||1,pct=parseFloat(b.getAttribute("data-pct"))||0;
        var unit=Math.round(mp*(1-pct/100));
        var te=b.querySelector("[data-total]"),ue=b.querySelector("[data-unit]");
        if(te)te.textContent=euro(unit*q);
        if(ue)ue.textContent=pct>0?(euro(unit)+" p.st."):"geen korting";
      });
      var extra=0,extraCount=0;
      bitems.forEach(function(bi){
        var p=parseInt(bi.getAttribute("data-price"),10)||0,pct=parseFloat(bi.getAttribute("data-pct"))||0;
        var bp=Math.round(p*(1-pct/100));
        var pe=bi.querySelector("[data-bprice]");if(pe)pe.textContent=euro(bp);
        var bq=parseInt(bi.getAttribute("data-qty"),10)||1;
        var fe=bi.querySelector("[data-bfull]");if(fe)fe.textContent=euro(p*bq);
        if(pe)pe.textContent=euro(bp*bq);
        if(bi.classList.contains("is-on")){extra+=bp*bq;extraCount++;}
      });
      var total=mainTotal+extra;
      var full=mp*t.qty; bitems.forEach(function(bi){if(bi.classList.contains("is-on"))full+=(parseInt(bi.getAttribute("data-price"),10)||0)*(parseInt(bi.getAttribute("data-qty"),10)||1);});
      var saved=full-total;
      var mt=root.querySelector("[data-maintotal]");if(mt)mt.textContent=euro(mainTotal);
      ["[data-grandtotal]","[data-grandtotal3]"].forEach(function(sel){var e=root.querySelector(sel);if(e)e.textContent=euro(total);});
      var lbl=root.querySelector("[data-totallbl]");if(lbl)lbl.textContent="Totaal ("+t.qty+"× "+mainLabel+(extraCount?" + "+extraCount+" extra":"")+")";
      var sv=root.querySelector("[data-saved]");if(sv){sv.hidden=!(saved>0);sv.textContent="Je bespaart "+euro(saved);}
      var toGo=Math.max(0,freeship-total);
      var fill=root.querySelector("[data-shipfill]");if(fill)fill.style.width=Math.min(100,total/freeship*100)+"%";
      var st=root.querySelector("[data-shiptxt]");
      if(st){if(toGo>0){st.classList.remove("is-done");st.innerHTML="Nog <strong>"+euro(toGo)+"</strong> tot <strong>gratis verzending</strong>";}
        else{st.classList.add("is-done");st.textContent="Gelukt — je bestelling wordt gratis verzonden";}}
      var mb=root.querySelector("[data-mbarsub]");
      if(mb)mb.textContent=t.qty+"× "+mainLabel+(extraCount?" + "+extraCount+" extra":"")+(toGo>0?" · nog "+euro(toGo)+" tot gratis verzending":" · gratis verzending");
      var setBtn=root.querySelector("[data-settotal]");
      if(setBtn)setBtn.textContent=(extraCount?"Bestel het complete setje":"In winkelwagen")+" · "+euro(total);
    }
    function addAll(btn,mainOnly){
      var t=curTier();
      var mv=varSel?varSel.value:root.getAttribute("data-main-variant");
      if(!mv)return;
      // staffel uit de tier-knoppen zelf ("1:0,2:10,3:15") — theme-editor stuurt zo ook de echte korting
      var qtyTiers=tierBtns.map(function(b){return (b.getAttribute("data-qty")||"1")+":"+(b.getAttribute("data-pct")||"0");}).join(",");
      var items=[{id:parseInt(mv,10),quantity:t.qty,properties:bundleId?{"_kind":"1","_kind_id":bundleId,"_kind_group":"main","_kind_qty_tiers":qtyTiers}:undefined}];
      bitems.forEach(function(bi){
        if(mainOnly)return;
        if(!bi.classList.contains("is-on"))return;
        items.push({id:parseInt(bi.getAttribute("data-variant"),10),quantity:(parseInt(bi.getAttribute("data-qty"),10)||1),properties:bundleId?{"_kind":"1","_kind_id":bundleId,"_kind_group":bi.getAttribute("data-group"),"_kind_pct":bi.getAttribute("data-pct")||"0"}:undefined});
      });
      var old=btn.textContent;var all=root.querySelectorAll(".kp-add");all.forEach(function(b){b.disabled=true;});btn.textContent="Toevoegen...";
      fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:items})})
        .then(function(r){return r.json();}).then(function(){
          track("hip_kind_add_to_cart",{kind_id:bundleId||"onbekend",items:items.length,page:location.pathname});
          // slide-cart (UpCart) openen i.p.v. naar de winkelwagenpagina sturen
          if(typeof window.upcartRefreshCart==="function")window.upcartRefreshCart();
          if(typeof window.upcartOpenCart==="function"){window.upcartOpenCart();btn.textContent=old;all.forEach(function(b){b.disabled=false;});update();}
          else{window.location.href="/cart";}
        })
        .catch(function(){all.forEach(function(b){b.disabled=false;});btn.textContent=old;});
    }
    root.querySelectorAll(".kp-add").forEach(function(b){b.addEventListener("click",function(){addAll(b,b.hasAttribute("data-main"));});});
    // levertijdregel wisselt mee met de voorraad van de gekozen variant (zelfde mechaniek als hip-dzo-main)
    var leverEl=root.querySelector("[data-lever]");
    function zetLever(){
      if(!leverEl)return;
      var o=varSel?varSel.options[varSel.selectedIndex]:null;
      var voorraad=parseInt((o&&o.getAttribute("data-voorraad"))||leverEl.getAttribute("data-voorraad"),10);
      if(isNaN(voorraad))voorraad=1;
      var uit=voorraad<=0&&leverEl.getAttribute("data-lever-uit");
      var t=leverEl.querySelector("[data-lever-tekst]");
      if(t)t.textContent=uit?leverEl.getAttribute("data-lever-uit"):leverEl.getAttribute("data-lever-in");
      leverEl.style.color=uit?leverEl.getAttribute("data-kleur-uit"):leverEl.getAttribute("data-kleur-in");
    }
    if(varSel)varSel.addEventListener("change",function(){zetLever();update();});
    zetLever();
    // cross-sell toevoegen
    root.querySelectorAll(".kp-xadd[data-variant]").forEach(function(b){b.addEventListener("click",function(){
      var old=b.textContent;b.disabled=true;b.textContent="Toegevoegd ✓";
      fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:[{id:parseInt(b.getAttribute("data-variant"),10),quantity:1}]})})
        .then(function(){setTimeout(function(){b.disabled=false;b.textContent=old;},1600);})
        .catch(function(){b.disabled=false;b.textContent=old;});
    });});
    update();
    track("hip_kind_view",{kind_id:bundleId||"onbekend",page:location.pathname});
  }
  function run(){document.querySelectorAll(".kp").forEach(init);}
  if(document.readyState!=="loading")run();else document.addEventListener("DOMContentLoaded",run);
  document.addEventListener("shopify:section:load",run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hip-teddy-beschrijving"] && !Shopify.designMode) return;
  try {
    
(function(){
  var txt = document.querySelector('[data-tpb-txt]');
  var btn = document.querySelector('[data-tpb-more]');
  if (!txt || !btn) return;
  function setup(){
    if (window.innerWidth >= 750) return;
    txt.classList.add('is-clamped');
    if (txt.scrollHeight > txt.clientHeight + 8) { btn.hidden = false; } else { txt.classList.remove('is-clamped'); }
  }
  btn.addEventListener('click', function(){
    var open = txt.classList.toggle('is-clamped') === false;
    btn.textContent = open ? 'Lees minder' : 'Lees meer';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  setup();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hip-teddy-main"] && !Shopify.designMode) return;
  try {
    
(function(){
  function euro(c){return "€ "+(c/100).toFixed(2).replace(".",",");}
  // Harde bovengrens: hoger dan dit mag de bundelkorting nooit worden.
  var MAX_PCT=15;
  // Standaard voor dekbedovertrekken; per sectie te overschrijven (zodat dezelfde
  // sectie ook voor hoeslakens werkt, met de upsell precies andersom).
  var MAATSUB_STD={"140x220":"1-persoons","200x220":"2-persoons","240x220":"lits-jumeaux","260x220":"lits-jumeaux XL"};
  var UPMAAT_STD={"140x220":"90x200","200x220":"140x200","240x220":"160x200","260x220":"180x200"};
  // "140x220=1-persoons, 200x220=2-persoons" -> object
  function parseMap(str,fallback){
    if(!str)return fallback;
    var out={},leeg=true;
    str.split(/[\n,;]+/).forEach(function(p){
      var d=p.split("=");
      if(d.length===2){var k=d[0].trim(),v=d[1].trim();if(k&&v){out[k]=v;leeg=false;}}
    });
    return leeg?fallback:out;
  }
  // Varianttitels verschillen ("200x220" vs "90x200 cm"): normaliseer voor de lookup.
  function maatKey(s){return (s||"").toLowerCase().replace(/\s|cm/g,"");}
  function mapLookup(map,titel){
    if(!map||!titel)return "";
    if(map[titel])return map[titel];
    var k=maatKey(titel);
    for(var key in map){if(maatKey(key)===k)return map[key];}
    return "";
  }
  function init(root){
    if(root.dataset.tpInit)return;root.dataset.tpInit="1";
    var MAATSUB=parseMap(root.getAttribute("data-maatsub"),MAATSUB_STD);
    var HOESLAKEN=parseMap(root.getAttribute("data-upmaat"),UPMAAT_STD);
    var pct=parseFloat(root.getAttribute("data-pct"))||10;
    var tier2Min=parseInt(root.getAttribute("data-cdmin"),10)||0;
    var tier2Pct=parseFloat(root.getAttribute("data-cdpct"))||0;
    if(pct>MAX_PCT)pct=MAX_PCT;
    if(tier2Pct>MAX_PCT)tier2Pct=MAX_PCT;
    var effHuidig=pct;
    var kleur=root.getAttribute("data-kleur")||"";
    // galerij
    var imgs=root.querySelectorAll(".tp-gal-img"),thumbs=root.querySelectorAll(".tp-thumb");
    thumbs.forEach(function(t){t.addEventListener("click",function(){
      var i=t.getAttribute("data-i");
      imgs.forEach(function(im){im.classList.toggle("is-on",im.getAttribute("data-i")===i);});
      thumbs.forEach(function(x){x.classList.toggle("is-on",x===t);});
    });});
    // maat
    var maten=[].slice.call(root.querySelectorAll(".tp-maat"));
    maten.forEach(function(m){
      var sub=m.querySelector("[data-sub]");if(sub)sub.textContent=mapLookup(MAATSUB,m.getAttribute("data-title"));
      m.addEventListener("click",function(){
        maten.forEach(function(x){x.classList.toggle("is-on",x===m);x.setAttribute("aria-checked",x===m?"true":"false");});
        try{history.replaceState(null,"",location.pathname+"?variant="+m.getAttribute("data-variant"));}catch(e){}
        update();
      });
    });
    function curMaat(){
      var m=root.querySelector(".tp-maat.is-on");
      if(m)return {id:m.getAttribute("data-variant"),price:parseInt(m.getAttribute("data-price"),10)||0,title:m.getAttribute("data-title")};
      return {id:root.getAttribute("data-main-variant"),price:parseInt(root.getAttribute("data-main-price"),10)||0,title:""};
    }
    // aantal
    var qty=1,qn=root.querySelector(".tp-qty-n");
    root.querySelectorAll(".tp-qty-b").forEach(function(b){b.addEventListener("click",function(){
      qty=Math.min(10,Math.max(1,qty+parseInt(b.getAttribute("data-d"),10)));qn.textContent=qty;update();
    });});
    // upsell
    var up=root.querySelector("[data-hoeslaken]");
    var upSel=up?up.querySelector(".tp-upsell-sel"):null;
    var upCheck=up?up.querySelector(".tp-upsell-item:not([data-extra]) .tp-upsell-check"):null;
    var extras=up?[].slice.call(up.querySelectorAll("[data-extra]")):[];
    // Suggestie op basis van de overtrekmaat; de klant kan zelf een andere maat kiezen.
    var upMaatZelfGekozen=false;
    function upSuggestie(maatTitle){
      if(!upSel)return null;
      var doel=mapLookup(HOESLAKEN,maatTitle);
      var opt=null;
      [].forEach.call(upSel.options,function(o){if(!opt&&doel&&o.textContent.indexOf(doel)>-1)opt=o;});
      return opt;
    }
    function upVariant(maatTitle){
      if(!upSel||!upSel.options.length)return null;
      if(!upMaatZelfGekozen){
        var s=upSuggestie(maatTitle);
        if(s)upSel.value=s.value;
      }
      return upSel.options[upSel.selectedIndex]||null;
    }
    if(upSel){upSel.addEventListener("change",function(){upMaatZelfGekozen=true;update();});}
    if(up){up.querySelectorAll(".tp-upsell-check").forEach(function(c){c.addEventListener("change",update);});}
    var upQty=1,upQtyRow=up?up.querySelector("[data-upqtyrow]"):null,upQtyN=up?up.querySelector("[data-upqty-n]"):null;
    if(upQtyRow){upQtyRow.querySelectorAll(".tp-upq-b").forEach(function(b){b.addEventListener("click",function(){
      upQty=Math.min(6,Math.max(1,upQty+parseInt(b.getAttribute("data-upd"),10)));if(upQtyN)upQtyN.textContent=upQty;update();
    });});}
    // aantal-steppers voor extra's (kussensloop e.d.)
    extras.forEach(function(x){
      x._q=1;
      var row=x.nextElementSibling;
      if(!row||!row.hasAttribute("data-extra-qtyrow"))return;
      x._qrow=row;
      var n=row.querySelector("[data-exq-n]");
      row.querySelectorAll(".tp-upq-b").forEach(function(b){b.addEventListener("click",function(){
        x._q=Math.min(6,Math.max(1,x._q+parseInt(b.getAttribute("data-upd"),10)));if(n)n.textContent=x._q;update();
      });});
    });
    // prijs op maatknoppen was al zichtbaar? (we tonen prijs alleen boven)
    function update(){
      var m=curMaat();
      var priceEl=root.querySelector("[data-price]");if(priceEl)priceEl.textContent=euro(m.price);
      var mainBtnTot=m.price*qty;
      var upOpt=upVariant(m.title);
      var upOn=!!(upCheck&&upCheck.checked&&upOpt);
      var upPrice=upOpt?parseInt(upOpt.getAttribute("data-price"),10)||0:0;
      // hoofdknop: alleen het overtrek
      root.querySelectorAll("[data-maintotal]").forEach(function(e){e.textContent=euro(mainBtnTot);});
      if(up){
        var aan=!!(upCheck&&upCheck.checked);
        var maatrij=up.querySelector("[data-upmaatrij]");if(maatrij)maatrij.hidden=!aan;
        var tip=up.querySelector("[data-upmaattip]");
        if(tip){
          var sug=upSuggestie(m.title);
          tip.hidden=!aan||!sug;
          if(aan&&sug){
            tip.textContent=(upOpt&&upOpt.value!==sug.value)
              ? "Afwijkend van ons advies ("+sug.textContent.trim()+") bij maat "+m.title+"."
              : "Ons advies bij maat "+m.title+". Past dat niet? Kies zelf een andere maat.";
          }
        }
        var upfull=up.querySelector("[data-upfull]");if(upfull)upfull.textContent=upOpt?euro(upPrice):"";
        if(upQtyRow)upQtyRow.hidden=!upOn;
        // extra's: kussenslopen tellen mee in de teddy-staffel, overige extra's niet
        var sloopTot=0,sloopQ=0,extraTot=0;
        extras.forEach(function(x){
          var on=x.querySelector(".tp-upsell-check").checked;
          if(x._qrow)x._qrow.hidden=!on;
          if(!on)return;
          var t=(parseInt(x.getAttribute("data-price"),10)||0)*(x._q||1);
          if(x.hasAttribute("data-sloop")){sloopTot+=t;sloopQ+=(x._q||1);}
          else{extraTot+=t;}
        });
        // staffel: 2 teddy-artikelen = pct, vanaf tier2Min artikelen = tier2Pct (nooit hoger)
        var stuks=qty+(upOn?upQty:0)+sloopQ;
        var eff=0,effLabel="";
        if(upOn&&tier2Min>0&&tier2Pct>0&&stuks>=tier2Min){eff=tier2Pct;effLabel=tier2Pct+"% korting vanaf "+tier2Min+" teddy-artikelen";}
        else if(upOn){eff=pct;effLabel=pct+"% korting op beide";}
        if(eff>MAX_PCT)eff=MAX_PCT;
        effHuidig=eff;
        var basis=m.price*qty+(upOn?upPrice*upQty:0)+(upOn?sloopTot:0);
        var vol=basis+extraTot+(upOn?0:sloopTot);
        // per regel afronden, exact zoals de kassa dat doet
        var afr=function(bedrag){return Math.round(bedrag*(1-eff/100));};
        var nu=(upOn?afr(m.price*qty)+afr(upPrice*upQty)+afr(sloopTot):basis+sloopTot)+extraTot;
        var toonPct=upOn?eff:pct;var upprice=up.querySelector("[data-upprice]");if(upprice)upprice.textContent=upOpt?euro(Math.round(upPrice*(1-toonPct/100))):"";
        var upfull2=up.querySelector("[data-upfull]");if(upfull2)upfull2.textContent=(upOpt&&toonPct>0)?euro(upPrice):"";
        var uppct=up.querySelector("[data-uppct]");if(uppct){uppct.textContent=toonPct>0?"-"+toonPct+"%":"";uppct.hidden=!(toonPct>0);}
        var usub=up.querySelector("[data-upsub]");if(usub)usub.textContent=(eff||pct)+"% korting op je dekbedovertrek én hoeslaken"+(eff>pct?" (vanaf "+tier2Min+" artikelen)":"");
        // kussensloop telt mee in de staffel zodra het hoeslaken erbij zit
        extras.forEach(function(x){if(!x.hasAttribute("data-sloop"))return;var sp=parseInt(x.getAttribute("data-price"),10)||0;
          var a=x.querySelector("[data-sloopprice]"),f=x.querySelector("[data-sloopfull]"),bd=x.querySelector("[data-sloopbadge]"),ls=x.querySelector("[data-slooplos]");
          var met=upOn&&eff>0;if(a)a.textContent=euro(met?Math.round(sp*(1-eff/100)):sp);if(f)f.textContent=met?euro(sp):"";if(bd){bd.hidden=!met;bd.textContent=met?"-"+eff+"%":"";}if(ls)ls.textContent=met?"":"per stuk";});
        var tot=up.querySelector("[data-uptot]");
        if(tot){tot.hidden=!upOn;
          var tv=up.querySelector("[data-tot-vol]"),tn=up.querySelector("[data-tot-nu]"),tb=up.querySelector("[data-tot-besp]");
          if(tv)tv.textContent=euro(vol);if(tn)tn.textContent=euro(nu);if(tb)tb.textContent=euro(vol-nu);}
        var bt=up.querySelector("[data-bundeltotal]");if(bt)bt.textContent=euro(nu);
        var bv=up.querySelector("[data-bundelvol]");if(bv)bv.textContent=(vol>nu)?euro(vol):"";
        var exAan=extras.some(function(x){return x.querySelector(".tp-upsell-check").checked;});
        var bb=up.querySelector("[data-add-bundel]");if(bb)bb.disabled=!(upOn||exAan);
      }
      // sticky balk
      var ms=root.querySelector("[data-mbarsub]");if(ms)ms.textContent=(m.title?m.title+" · ":"")+kleur;
      var mp=root.querySelector("[data-mbarprice]");if(mp)mp.textContent=euro(mainBtnTot);
    }
    // Het thema rendert de teller in de header alleen serverside; na een fetch-toevoeging
    // werken we hem zelf bij (span.cart-count, verborgen via .visually-hidden bij 0).
    function refreshCartCount(){
      fetch("/cart.js",{headers:{"Accept":"application/json"}})
        .then(function(r){return r.json();})
        .then(function(c){
          var n=c.item_count||0;
          document.querySelectorAll(".cart-count").forEach(function(el){
            el.textContent=n;
            if(n>0)el.classList.remove("visually-hidden");else el.classList.add("visually-hidden");
          });
          try{document.dispatchEvent(new CustomEvent("cart:refresh",{bubbles:true,detail:{cart:c}}));}catch(e){}
        }).catch(function(){});
    }
    function addItems(items,btn){
      var old=btn.textContent;btn.disabled=true;btn.textContent="Toevoegen...";
      fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:items})})
        .then(function(r){if(!r.ok)throw new Error(r.status);return r.json();})
        .then(function(){
          refreshCartCount();
          try{window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:"hip_teddy_add_to_cart",items:items.length,page:location.pathname});}catch(e){}
          if(typeof window.upcartRefreshCart==="function")window.upcartRefreshCart();
          // teller nogmaals bijwerken nadat de slide-cart klaar is met verwerken
          setTimeout(refreshCartCount,1200);
          if(typeof window.upcartOpenCart==="function"){window.upcartOpenCart();btn.textContent=old;btn.disabled=false;}
          else{window.location.href="/cart";}
        })
        .catch(function(){btn.disabled=false;btn.textContent=old;});
    }
    root.querySelectorAll("[data-add-main]").forEach(function(b){b.addEventListener("click",function(){
      var m=curMaat();if(!m.id)return;
      addItems([{id:parseInt(m.id,10),quantity:qty}],b);
    });});
    var bundelBtn=root.querySelector("[data-add-bundel]");
    if(bundelBtn){bundelBtn.addEventListener("click",function(){
      var m=curMaat();var upOpt=upVariant(m.title);
      if(!m.id)return;
      var items=[];
      var tiers="2:"+Math.min(effHuidig||pct,MAX_PCT);
      var bundelAan=!!(upCheck&&upCheck.checked&&upOpt);
      if(bundelAan){
        // De korting die de PDP toont sturen we 1-op-1 mee als staffel, zodat
        // kassa en pagina altijd hetzelfde percentage hanteren.
        items.push({id:parseInt(m.id,10),quantity:qty,properties:{"_bundle":"1","_bundle_group":"overtrek","_bundle_tiers":tiers}});
        items.push({id:parseInt(upOpt.value,10),quantity:upQty,properties:{"_bundle":"1","_bundle_group":"hoeslaken","_bundle_tiers":tiers}});
      }else{
        items.push({id:parseInt(m.id,10),quantity:qty});
      }
      extras.forEach(function(x){
        if(!x.querySelector(".tp-upsell-check").checked)return;
        var it={id:parseInt(x.getAttribute("data-variant"),10),quantity:x._q||1};
        if(bundelAan&&x.hasAttribute("data-sloop")){it.properties={"_bundle":"1","_bundle_group":"sloop","_bundle_tiers":tiers};}
        items.push(it);
      });
      addItems(items,bundelBtn);
    });}
    // sticky balk: tonen na scrollen voorbij het koopblok
    var mbar=root.querySelector("[data-mbar]");
    var buy=root.querySelector(".tp-buy");
    if(mbar&&buy&&"IntersectionObserver" in window){
      new IntersectionObserver(function(en){mbar.hidden=en[0].isIntersecting;},{rootMargin:"-80px 0px 0px 0px"}).observe(buy);
    }
    update();
    // teller ook bijwerken als de klant in de slide-cart iets wijzigt en terugkomt
    document.addEventListener("visibilitychange",function(){if(!document.hidden)refreshCartCount();});
    try{window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:"hip_teddy_view",page:location.pathname});}catch(e){}
  }
  function run(){document.querySelectorAll(".tp").forEach(init);}
  if(document.readyState!=="loading")run();else document.addEventListener("DOMContentLoaded",run);
  document.addEventListener("shopify:section:load",run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hip-teddy-social"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.tpk-vidwrap').forEach(function(w){
  var v = w.querySelector('video');
  if (!v) return;
  function toggle(){
    if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function(){}); } else { v.pause(); }
  }
  v.addEventListener('play', function(){ w.classList.add('is-playing');
    document.querySelectorAll('.tpk-vidwrap video').forEach(function(o){ if (o !== v && !o.paused) o.pause(); });
  });
  v.addEventListener('pause', function(){ w.classList.remove('is-playing'); });
  w.querySelector('.tpk-play').addEventListener('click', toggle);
  v.addEventListener('click', toggle);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navigation-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super()
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      }
      this.querySelectorAll('a').forEach((item) =>
        item.addEventListener('click', this.onItemClick.bind(this))
      )
    }

    onItemClick(event) {
      event.preventDefault()
      const form = this.querySelector('form')
      this.elements.input.value = event.currentTarget.dataset.value
      if (form) form.submit()
    }
  }

  customElements.define('localization-form', LocalizationForm)


  } catch(e) { console.error(e); }
})();
})();
